"use client";

import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { TabToggleWithOverflow } from "@/components/common/TabToggleWithOverflow";
import WaveHeader from "@/components/waves/header/WaveHeader";
import BrainRightSidebarContent from "./BrainRightSidebarContent";
import BrainRightSidebarFollowers from "./BrainRightSidebarFollowers";
import { Mode, SidebarTab } from "./BrainRightSidebarTypes";
import { WaveLeaderboardRightSidebarVoters } from "@/components/waves/leaderboard/sidebar/WaveLeaderboardRightSidebarVoters";
import { WaveLeaderboardRightSidebarActivityLogs } from "@/components/waves/leaderboard/sidebar/WaveLeaderboardRightSidebarActivityLogs";
interface WaveContentProps {
  readonly wave: ApiWave;
  readonly mode: Mode;
  readonly setMode: (mode: Mode) => void;
  readonly activeTab: SidebarTab;
  readonly setActiveTab: (tab: SidebarTab) => void;
}
interface TabOption {
  key: SidebarTab;
  label: string;
}
export const WaveContent: React.FC<WaveContentProps> = t0 => {
  const $ = _c(42);
  const {
    wave,
    mode,
    setMode,
    activeTab,
    setActiveTab
  } = t0;
  let t1;
  if ($[0] !== mode || $[1] !== setMode) {
    t1 = () => setMode(mode === Mode.FOLLOWERS ? Mode.CONTENT : Mode.FOLLOWERS);
    $[0] = mode;
    $[1] = setMode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onFollowersClick = t1;
  const isRankWave = wave.wave.type === ApiWaveType.Rank;
  const isApproveWave = wave.wave.type === ApiWaveType.Approve;
  const isCompetitionWave = isRankWave || isApproveWave;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      key: SidebarTab.ABOUT,
      label: "About"
    }, {
      key: SidebarTab.TOP_VOTERS,
      label: "Voters"
    }, {
      key: SidebarTab.ACTIVITY_LOG,
      label: "Activity"
    }];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const options = t2;
  let t3;
  if ($[4] !== onFollowersClick || $[5] !== wave) {
    t3 = <WaveHeader wave={wave} onFollowersClick={onFollowersClick} useRing={false} useRounded={false} />;
    $[4] = onFollowersClick;
    $[5] = wave;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== mode || $[8] !== setMode || $[9] !== wave) {
    t4 = mode === Mode.CONTENT ? <BrainRightSidebarContent wave={wave} /> : <BrainRightSidebarFollowers wave={wave} closeFollowers={() => setMode(Mode.CONTENT)} />;
    $[7] = mode;
    $[8] = setMode;
    $[9] = wave;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="tw-h-full tw-divide-x-0 tw-divide-y tw-divide-solid tw-divide-iron-700">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== wave) {
    t6 = <div className="tw-p-4"><WaveLeaderboardRightSidebarVoters wave={wave} /></div>;
    $[14] = wave;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== wave) {
    t7 = <div className="tw-p-4"><WaveLeaderboardRightSidebarActivityLogs wave={wave} /></div>;
    $[16] = wave;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = {
      [SidebarTab.ABOUT]: t5,
      [SidebarTab.TOP_VOTERS]: t6,
      [SidebarTab.ACTIVITY_LOG]: t7
    };
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const competitionWaveComponents = t8;
  const activeCompetitionTab = competitionWaveComponents[activeTab] ? activeTab : SidebarTab.ABOUT;
  if (!isCompetitionWave) {
    let t9;
    if ($[22] !== onFollowersClick || $[23] !== wave) {
      t9 = <WaveHeader wave={wave} onFollowersClick={onFollowersClick} useRing={false} useRounded={false} />;
      $[22] = onFollowersClick;
      $[23] = wave;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    let t10;
    if ($[25] !== mode || $[26] !== setMode || $[27] !== wave) {
      t10 = mode === Mode.CONTENT ? <BrainRightSidebarContent wave={wave} /> : <BrainRightSidebarFollowers wave={wave} closeFollowers={() => setMode(Mode.CONTENT)} />;
      $[25] = mode;
      $[26] = setMode;
      $[27] = wave;
      $[28] = t10;
    } else {
      t10 = $[28];
    }
    let t11;
    if ($[29] !== t10 || $[30] !== t9) {
      t11 = <div className="tw-h-full tw-divide-x-0 tw-divide-y tw-divide-solid tw-divide-iron-700">{t9}{t10}</div>;
      $[29] = t10;
      $[30] = t9;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    return t11;
  }
  let t9;
  if ($[32] !== setActiveTab) {
    t9 = key => setActiveTab(key as SidebarTab);
    $[32] = setActiveTab;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] !== activeTab || $[35] !== t9) {
    t10 = <div className="tw-pb-px tw-pl-2.5"><TabToggleWithOverflow options={options} activeKey={activeTab} onSelect={t9} maxVisibleTabs={3} /></div>;
    $[34] = activeTab;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  const t11 = competitionWaveComponents[activeCompetitionTab];
  let t12;
  if ($[37] !== t11) {
    t12 = <div>{t11}</div>;
    $[37] = t11;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t10 || $[40] !== t12) {
    t13 = <>{t10}{t12}</>;
    $[39] = t10;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  return t13;
};